import React, {useState} from 'react';
import Modal from 'Shared/components/Modal';
import {Button} from '@material-ui/core';
import {useDispatch} from 'react-redux';
import {resetUserPassword} from 'Users/ducks/userAdministration';
import 'Users/components/UserAdministration/ResetUserPasswordConfirmationModal.sass';
import Loading from 'Shared/components/Loading';

type ResetUserPasswordConfirmationModalProps = {
  userId: string;
  username: string;
  onClose: () => void;
  open: boolean;
};

const ResetUserPasswordConfirmationModal = (props: ResetUserPasswordConfirmationModalProps) => {
  const {username, onClose, open, userId} = props;
  const [isResetting, setIsResetting] = useState(false);
  const dispatch = useDispatch();

  return (
    <Modal
      className="reset-user-password-confirmation-modal"
      title={`Reset ${username}'s Password?`}
      onClose={onClose}
      open={open}
      disableBackdropClick
    >
      {isResetting ? (
        <Loading />
      ) : (
        <>
          <div className="reset-user-password-confirmation-modal__body">
            <h2 className="reset-user-password-confirmation-modal__title">
              Are You Sure You Want To Reset {username}'s Password?
            </h2>
            <p>
              Resetting this user's password will generate a new temporary password and send it to them via the email we
              have on file.
            </p>
          </div>
          <div className="reset-user-password-confirmation-modal__actions">
            <Button className="actions__cancel-button" onClick={onClose} variant="contained">
              Cancel
            </Button>
            <Button
              className="actions__delete-button"
              onClick={() => {
                setIsResetting(true);
                dispatch(resetUserPassword(userId, onClose));
              }}
              color="primary"
              variant="contained"
            >
              Reset Password
            </Button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default ResetUserPasswordConfirmationModal;
